<template>
  <b-container class="mt-3 mb-3" fluid>
    <h3>Orders</h3>
    <hr />
    <b-row>
      <b-col v-if="!selectedOrder">
        <b-row>
          <b-col class="d-flex justify-content-start">
            <b-button
              variant="blue"
              size="sm"
              @click="onAddOrder"
              style="height:35px;"
            >
              <b-icon-plus />
              Start an order
            </b-button>
          </b-col>
          <b-col class="justify-content-end">
            <b-form-group
              label="Status Filter:"
              label-cols="6"
              label-align="right"
              v-if="!selectedOrder"
            >
              <b-select v-model="filters" @change="onFilterSelect">
                <b-select-option value="Open">
                  Open Orders
                </b-select-option>
                <b-select-option value="">
                  All Orders
                </b-select-option>
                <b-select-option value="Started">
                  Started
                </b-select-option>
                <b-select-option value="Placed">
                  Placed
                </b-select-option>
                <b-select-option value="Acknowledged">
                  Acknowledged
                </b-select-option>
                <b-select-option value="Shipped">
                  Shipped
                </b-select-option>
                <b-select-option value="Delivered">
                  Delivered
                </b-select-option>
              </b-select>
            </b-form-group>
          </b-col>
        </b-row>
        <hr />
        <!-- Sys Admin -->
        <dx-data-grid
          :data-source.sync="orders"
          :columns="gridSettings.columns['admin']"
          :allowColumnResizing="true"
          :height="750"
          :onRowDblClick="onselectionchange"
          :selection="gridSettings.selection"
          :filter-row="gridSettings.filterRow"
          :header-filter="gridSettings.headerFilter"
          :search-panel="gridSettings.searchPanel"
          :paging="gridSettings.paging"
          :pager="gridSettings.pager"
          :remoteOperations="gridSettings.remoteOps"
          ref="gOrd"
          v-if="authType === 'sa'"
        />

        <!-- C/CA -->
        <dx-data-grid
          :data-source.sync="orders"
          :columns="gridSettings.columns['customer']"
          :allowColumnResizing="true"
          :height="750"
          :onRowDblClick="onselectionchange"
          :selection="gridSettings.selection"
          :filter-row="gridSettings.filterRow"
          :header-filter="gridSettings.headerFilter"
          :search-panel="gridSettings.searchPanel"
          :paging="gridSettings.paging"
          :pager="gridSettings.pager"
          :remoteOperations="gridSettings.remoteOps"
          ref="gOrd"
          v-else
        />
      </b-col>

      <!-- Editor -->
      <b-col v-if="selectedOrder">
        <b-overlay spinner-type="grow" :show="saving">
          <template v-slot:overlay>
            <div class="text-center">
              <b-icon-stopwatch
                font-scale="3"
                animation="cylon"
              ></b-icon-stopwatch>
              <p id="cancel-label">Saving, please wait...</p>
            </div>
          </template>

          <!-- Buttons -->
          <b-row>
            <b-col>
              <div class=" d-flex justify-content-start">
                <b-button variant="orange" @click="onCancelClick">
                  Return to orders
                </b-button>
              </div>
            </b-col>
            <b-col>
              <div class="d-flex justify-content-end">
                <b-button
                  variant="blue"
                  @click="onEditClick"
                  v-if="authType === 'sa' && selectedOrder.id"
                >
                  <span v-if="!editOrder">
                    <b-icon-pencil />
                    Edit Order
                  </span>
                  <span v-else>
                    <b-icon-pencil class="mb-1" />
                    Cancel Edit
                  </span>
                </b-button>
              </div>
            </b-col>
          </b-row>
          <hr />
          <b-form
            :class="{
              'needs-validation': !submitted,
              'was-validated': submitted
            }"
            novalidate
            ref="f"
          >
            <b-row>
              <!-- Details -->
              <b-col>
                <b-container>
                  <span class="display-title">
                    Order#
                    {{
                      selectedOrder.number
                        ? selectedOrder.number
                        : "--New Order--"
                    }}
                    <br />
                  </span>
                  <!-- <b-form> -->
                  <!-- Header -->
                  <b-row>
                    <!-- Order Status Info -->
                    <b-col>
                      <!-- Items -->
                      <b-card title="In this order">
                        <b-card-body>
                          <b-container fluid>
                            <!-- <h4 >In this order</h4> -->
                            <dx-data-grid
                              :data-source="selectedOrder.order_items"
                              :columns="gridOrderItem.displayColumns"
                              v-if="!editOrder"
                            />

                            <b-form
                              :class="{
                                'needs-validation': !submitted,
                                'was-validated': submitted
                              }"
                              v-else
                            >
                              <b-row>
                                <b-col>
                                  <b-row class="mb-2">
                                    <b-col class="d-flex justify-content-end">
                                      <span style="color:red;font-style:italic;"
                                        >Your favorite items automatically
                                        appear in the order.</span
                                      >
                                    </b-col>
                                  </b-row>
                                  <dx-data-grid
                                    :data-source="selectedOrder.order_items"
                                    :columns="gridOrderItem.editColumns"
                                    :editing="gridOrderItem.editing"
                                    :showRowLines="true"
                                    :onRowUpdated="onRowUpdated"
                                    :onRowRemoving="onRemovingItem"
                                    ref="grdItems"
                                  >
                                    <template #description="{data}">
                                      <div>
                                        <span v-if="!data.data.inExistingOrder">
                                          {{ data.data.description }}
                                        </span>
                                        <span v-else>
                                          {{ data.data.description }}
                                          <!-- <i class="ml-2" style="color:red;">
                                            This item is already part of a
                                            pending order
                                          </i> -->
                                        </span>
                                      </div>
                                    </template>
                                  </dx-data-grid>
                                  <hr />
                                  <b-input-group class="mt-3">
                                    <b-select
                                      :options="options"
                                      v-model="selectedItem"
                                    >
                                      <template #first>
                                        <b-select-option :value="null" disabled>
                                          -- Choose an item --
                                        </b-select-option>
                                      </template>
                                    </b-select>
                                    <template #append>
                                      <b-button
                                        variant="blue"
                                        @click="onAddItem"
                                        :disabled="!selectedItem"
                                      >
                                        Add to order
                                      </b-button>
                                    </template>
                                  </b-input-group>
                                  <br />
                                  <b-checkbox
                                    v-model="addToFavorite"
                                    :value="true"
                                    v-if="selectedItem"
                                  >
                                    Add to favorites
                                  </b-checkbox>
                                </b-col>
                              </b-row>
                            </b-form>
                          </b-container>
                        </b-card-body>
                      </b-card>
                    </b-col>

                    <!-- Shipping and Notes info -->
                    <b-col class="mt-2" :md="12">
                      <b-row>
                        <b-col v-if="!editOrder && authType === 'sa'">
                          <b-card title="Shipping & Delivery">
                            <b-card-body>
                              <div style="z-index:2;">
                                <span>
                                  <span class="mr-2" style="font-weight:bold;">
                                    Tracking Number:
                                  </span>
                                  <br />
                                  {{
                                    selectedOrder.tracking_number === "" ||
                                    selectedOrder.tracking_number === null
                                      ? "--"
                                      : selectedOrder.tracking_number
                                  }}
                                </span>
                                <br />
                                <span>
                                  <span class="mr-2" style="font-weight:bold;">
                                    Shipped Via:
                                  </span>
                                  <br />
                                  {{
                                    selectedOrder.shipped_via === "" ||
                                    selectedOrder.shipped_via === null
                                      ? "--"
                                      : selectedOrder.shipped_via
                                  }}
                                </span>
                                <br />
                                <span>
                                  <span class="mr-2" style="font-weight:bold;">
                                    Notes:
                                  </span>
                                  <br />
                                  <span>
                                    {{ selectedOrder.notes }}
                                  </span>
                                </span>
                                <br />
                              </div>
                            </b-card-body>
                          </b-card>
                        </b-col>

                        <b-col v-else-if="editOrder && authType === 'sa'">
                          <b-card title="Shipping & Delivery">
                            <b-card-body>
                              <div style="z-index:2;">
                                <br />
                                <span
                                  class="order-content"
                                  v-if="authType === 'sa'"
                                >
                                  <b-form-group>
                                    <span style="color:black;">
                                      Shipped Via:
                                    </span>
                                    <b-select
                                      v-model="selectedOrder.shipped_via"
                                    >
                                      <b-select-option value="" disabled>
                                        -- Shipped Via --
                                      </b-select-option>
                                      <b-select-option value="UPS">
                                        UPS
                                      </b-select-option>
                                      <b-select-option value="FedEx">
                                        FedEx
                                      </b-select-option>
                                    </b-select>
                                  </b-form-group>
                                  <b-form-group
                                    v-if="
                                      selectedOrder.shipped_via &&
                                        selectedOrder.shipped_via.length > 0 &&
                                        editOrder
                                    "
                                  >
                                    <span style="color:black;">
                                      Tracking Number:
                                    </span>
                                    <b-input
                                      v-model="selectedOrder.tracking_number"
                                      type="text"
                                      :maxlength="255"
                                    />
                                  </b-form-group>
                                  <span
                                    v-else-if="
                                      selectedOrder.shipped_via &&
                                        selectedOrder.shipped_via.length > 0 &&
                                        !editOrder
                                    "
                                  >
                                    <span style="color:#000!important;">
                                      Tracking Number:
                                    </span>
                                    <br />
                                    <span>{{
                                      selectedOrder.tracking_number
                                    }}</span>
                                  </span>
                                </span>

                                <hr />
                                <b-form-group
                                  class="order-content"
                                  title="Delivered at"
                                  label="Delivered at:"
                                >
                                  <b-row
                                    class="mt-2"
                                    v-if="
                                      selectedOrder.shipped_via &&
                                        selectedOrder.shipped_via.length > 0 &&
                                        editOrder
                                    "
                                  >
                                    <b-col class="d-fdlex justify-content-left">
                                      <dx-calendar
                                        v-model="selectedOrder.delivered_at"
                                      />
                                    </b-col>
                                  </b-row>
                                  <b-row class="mt-2">
                                    <b-col
                                      class="justify-content-center"
                                      :md="5"
                                      v-if="
                                        selectedOrder.shipped_via &&
                                          selectedOrder.shipped_via.length >
                                            0 &&
                                          editOrder
                                      "
                                    >
                                      <b-form-group
                                        label="Time:"
                                        :lable-cols="1"
                                        label-align="left"
                                      >
                                        <dx-date-box
                                          type="time"
                                          pickerType="native"
                                          dateSerializationFormat="yyyy-MM-ddTHH:mm:ss"
                                          v-model="selectedOrder.delivered_at"
                                          :adaptivityEnabled="true"
                                          :visible="true"
                                          :element-attr="{ class: 'dx-box' }"
                                          :width="285"
                                        />
                                      </b-form-group>
                                    </b-col>
                                  </b-row>
                                </b-form-group>
                                <br />
                              </div>
                            </b-card-body>
                          </b-card>
                        </b-col>
                      </b-row>
                      <!-- Notes -->
                      <b-row>
                        <b-col>
                          <b-card title="Notes" v-if="!editOrder">
                            <b-card-body>
                              {{ selectedOrder.notes }}
                            </b-card-body>
                          </b-card>
                          <b-card title="Notes" v-else>
                            <b-card-body>
                              <b-textarea
                                v-model="selectedOrder.notes"
                                maxlength="255"
                                style="min-height:250px;"
                              />
                            </b-card-body>
                          </b-card>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>

                  <hr />
                  <!-- Due by -->
                  <b-row>
                    <b-col class="d-flex justify-content-start">
                      <b-checkbox
                        title="Rush this order."
                        v-model="selectedOrder.rush"
                        @change="byteConvert"
                        v-if="editOrder && selectedOrder.status === 'Started'"
                      >
                        Rush this order.
                      </b-checkbox>
                    </b-col>
                  </b-row>
                  <b-row v-if="selectedOrder.rush === 1">
                    <b-col>
                      <h4 v-if="editOrder">Due By</h4>
                      <b-row>
                        <b-col class="d-flex mt-1 justify-content-start">
                          <span style="color:red;font-style:italic;">
                            Normal delivery time can take 3 to 5 business days
                            additional charges may apply on rush orders.
                          </span>
                        </b-col>
                      </b-row>
                      <span v-if="!editOrder">
                        {{ toDateString(selectedOrder.due_by) }}
                      </span>
                      <span class="order-content" v-else>
                        <span style="font-weight:bold;">
                          Due:
                        </span>
                        <b-row>
                          <b-col>
                            <!-- <b-form v-if="selectedOrder.rush"> -->
                            <b-row class="mt-2">
                              <b-col class="d-flex justify-content-left">
                                <span class="mb-1 text-dark">
                                  Date:
                                </span>
                                <br />
                                <dx-calendar v-model="selectedOrder.due_by" />
                              </b-col>
                            </b-row>
                            <b-row class="mt-2">
                              <b-col class="justify-content-center" :md="5">
                                <b-form-group
                                  label="Time:"
                                  :lable-cols="1"
                                  label-align="left"
                                >
                                  <span class="mb-1 text-dark">Time:</span>
                                  <br />
                                  <dx-date-box
                                    type="time"
                                    pickerType="native"
                                    dateSerializationFormat="yyyy-MM-ddTHH:mm:ss"
                                    v-model="selectedOrder.due_by"
                                    :adaptivityEnabled="true"
                                    :visible="true"
                                    :element-attr="{ class: 'dx-box' }"
                                    :width="285"
                                  />
                                </b-form-group>
                              </b-col>
                            </b-row>
                            <hr v-if="selectedOrder.rush === 1" />
                            <!-- </b-form> -->
                          </b-col>
                        </b-row>
                      </span>
                    </b-col>
                  </b-row>
                  <hr />
                  <!-- Action Buttons -->
                  <b-row class="mt-3 mb-5" v-if="editOrder">
                    <b-col v-if="selectedOrder.status === 'Started'">
                      <div class="d-flex justify-content-start">
                        <b-button
                          class="action-button"
                          variant="blue"
                          @click.stop.prevent="onSubmit"
                          id="sub"
                        >
                          Place Order
                        </b-button>
                      </div>
                    </b-col>
                    <b-col>
                      <div class="d-flex justify-content-start">
                        <b-button
                          class="action-button"
                          variant="info"
                          @click.stop.prevent="onSubmit"
                          id="sav"
                        >
                          <span v-if="selectedOrder.status === 'Started'">
                            Save for later
                          </span>
                          <span v-else>
                            Save Changes
                          </span>
                        </b-button>
                      </div>
                    </b-col>
                    <b-col
                      v-if="
                        selectedOrder.id &&
                          selectedOrder.id > 0 &&
                          selectedOrder.status === 'Started'
                      "
                    >
                      <div class=" d-flex justify-content-center">
                        <b-button variant="danger" @click="onCancelOrderClick">
                          <b-icon-trash-fill class="mb-1" />
                          Cancel Order
                        </b-button>
                      </div>
                    </b-col>
                  </b-row>
                  <!-- </b-form> -->
                </b-container>
              </b-col>
              <!-- Order header -->
              <b-col :md="3">
                <b-row>
                  <b-col> </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div style="z-index:2;">
                      <span style="font-weight:bold;">Customer:</span>
                      <!-- <b-form> -->
                      <b-form-group
                        v-if="
                          (authType === 'ca' || authType === 'sa') && editOrder
                        "
                      >
                        <b-select
                          :options="siteOptions"
                          v-model="selectedOrder.site_id"
                          @change="onOrderUpdated"
                          :disabled="selectedOrder.status !== 'Started'"
                          style="max-width:285px;"
                          required
                        />
                      </b-form-group>
                      <span v-else>
                        {{
                          selectedOrder.account_name.length > 0
                            ? selectedOrder.account_name +
                              " / " +
                              selectedOrder.site_name
                            : ""
                        }}
                      </span>
                      <br />
                      <span>
                        <span class="mr-2" style="font-weight:bold;">
                          Placed by:
                        </span>
                        {{ selectedOrder.user_name }}
                      </span>
                      <br />
                      <span>
                        <span class="mr-2" style="font-weight:bold;">
                          Placed:
                        </span>
                        {{ selectedOrder.placed }}
                      </span>
                      <br />
                      <span>
                        <span class="mr-2" style="font-weight:bold;">
                          Status:
                        </span>
                        <span
                          :class="{
                            'order-delayed':
                              selectedOrder.total_days > 10 &&
                              selectedOrder.status !== 'Delivered',
                            'order-delivered':
                              selectedOrder.status === 'Delivered'
                          }"
                          v-if="selectedOrder.id"
                        >
                          <span
                            v-if="
                              !editOrder || (editOrder && authType !== 'sa')
                            "
                          >
                            {{ selectedOrder.status }}
                          </span>
                          <!-- <b-select
                          v-model="selectedOrder.status"
                          v-else-if="editOrder && authType === 'sa'"
                          style="max-width:285px;"
                          required
                        >
                          <template #first>
                            <b-select-option :value="null || ''">
                              -- Select a status --
                            </b-select-option>
                          </template>
                          <b-select-option value="Acknowledged">
                            Acknowledged
                          </b-select-option>
                          <b-select-option value="Shipped">
                            Shipped
                          </b-select-option>
                          <b-select-option value="Delivered">
                            Delivered
                          </b-select-option>
                          <b-select-option value="Placed">
                            Placed
                          </b-select-option>
                          <b-select-option value="Started">
                            Started
                          </b-select-option>
                        </b-select> -->
                        </span>
                        <span v-else>
                          --
                        </span>
                      </span>
                      <br />
                      <span
                        v-if="
                          authType === 'sa' &&
                            selectedOrder.status !== 'Delivered' &&
                            selectedOrder.id
                        "
                      >
                        <span>
                          Set status to:
                        </span>
                        <b-button
                          variant="blue"
                          @click="onStatusChange($event.target)"
                          :id="selectedOrder ? nextStatus.id : 'Started'"
                        >
                          {{
                            selectedOrder ? nextStatus.text : "Set to Started"
                          }}
                        </b-button>
                      </span>
                      <!-- </b-form> -->
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-overlay>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { confirm } from "devextreme/ui/dialog";
import notify from "devextreme/ui/notify";

export default {
  components: {
    // DxDataGrid,
    // DxForm
  },
  props: ["ord"],
  data() {
    return {
      _curOrd: null,
      // selectedOrder: {},
      selectedOrder: null,
      editOrder: false,
      selectedItem: null,
      addToFavorite: false,
      saving: false,
      submitted: false,
      statusButton: {
        Started: {
          id: "sta",
          text: "Set to Started"
        },
        Placed: {
          id: "pla",
          text: "Placed"
        },
        Acknowledged: {
          id: "ack",
          text: "Acknowledged"
        },
        Shipped: {
          id: "shi",
          text: "Shipped"
        },
        Delivered: {
          id: "del",
          text: "Delivered"
        }
      },
      formFields: [
        {
          dataField: "status",
          editorType: "dxSelectBox",
          editorOptions: {
            items: ["Delivered", "Placed", "Started", "Acknowledged"]
          }
        },
        {
          dataField: "delivered",
          editorType: "dxCheckBox"
        },
        {
          dataField: "notes",
          editorType: "dxTextArea",
          editorOptions: {
            height: 200
          }
        }
      ],
      deliveryFormFields: [
        "tracking_number",
        {
          dataField: "shipped_via",
          editorType: "dxSelectBox",
          editorOptions: {
            items: ["FedEx", "UPS"]
          }
        },
        {
          dataField: "delivered_at",
          editorType: "dxDateBox",
          editorOptions: {
            type: "datetime"
          }
        }
      ],
      gridSettings: {
        columns: {
          customer: [
            {
              dataField: "number",
              width: 150
            },
            {
              dataField: "account_name"
            },
            // {
            //   calculateDisplayValue(e) {
            //     //look into making tracking numbers hyperlinks depending on carrier.
            //     return '<a href="http://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=number"/>';
            //   }
            // },
            {
              dataField: "site_name",
              caption: "Location"
            },
            {
              dataField: "status",
              calculateDisplayValue(e) {
                debugger;
                var stat =
                  e.status === "Started" || e.status === "Placed"
                    ? e.status + " by " + e.user_name
                    : e.status;

                return stat;
              }
            },
            {
              dataField: "updated_at",
              caption: "Last activity",
              dataType: "date",
              sortOrder: "desc",
              width: 150
            },
            {
              // dataField: "due_by",
              // dataType: "datetime",
              caption: "Due",
              dataField: "due_by",
              width: 250,
              calculateDisplayValue(e) {
                // debugger;
                if (e.rush === 1) {
                  var dt = new Date(e.due_by);
                  return (
                    dt.toLocaleDateString() + " by " + dt.toLocaleTimeString()
                  );
                } else {
                  return "";
                }
              },
              visible(e) {
                debugger;
              }
            }
            // {}
          ],
          admin: [
            {
              dataField: "number",
              width: 150
            },
            {
              dataField: "account_name"
            },
            // {
            //   calculateDisplayValue(e) {
            //     //look into making tracking numbers hyperlinks depending on carrier.
            //     return '<a href="http://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=number"/>';
            //   }
            // },
            {
              dataField: "site_name",
              caption: "Location",
              width: 150
            },
            {
              dataField: "status",
              width: 150
            },
            {
              dataField: "updated_at",
              caption: "Last Aativity",
              dataType: "date",
              sortOrder: "desc",
              width: 150
            },
            {
              // dataField: "due_by",
              // dataType: "datetime",
              caption: "Due",
              dataField: "due_by",
              calculateDisplayValue(e) {
                // debugger;
                if (e.rush === 1) {
                  var dt = new Date(e.due_by);
                  return (
                    dt.toLocaleDateString() + " by " + dt.toLocaleTimeString()
                  );
                } else {
                  return "";
                }
              }
            }
            // {}
          ]
        },
        selection: {
          mode: "single"
        },
        headerFilter: {
          allowSearch: true,
          visible: false
        },
        filterRow: {
          visible: false
        },
        searchPanel: {
          highlightSearchText: true,
          visible: true,
          width: 250
        },
        pager: {
          showPageSizeSelector: true,
          showInfo: true,
          allowedPageSizes: [25, 50, 100]
        },
        paging: {
          pageSize: 25
        },
        remoteOps: {
          paging: true
        }
      },
      gridOrderItem: {
        displayColumns: [
          {
            calculateDisplayValue(e) {
              return e.quantity + " x " + e.description;
            }
          }
        ],
        editColumns: [
          {
            caption: "Item",
            dataField: "description",
            // calculateDisplayValue(e) {
            //   debugger;
            //   return (
            //     e.quantity +
            //     " x " +
            //     e.description +
            //     (e.inExistingOrder
            //       ? ",This item is already part of a pending order"
            //       : "")
            //   );
            // },
            cellTemplate: "description",
            // customizeText(cellInfo) {
            //   debugger;
            //   if (cellInfo.value.split(",").length > 1) {
            //     return (
            //       cellInfo.value.split(",")[0] +
            //       '<i style="color:red;>' +
            //       cellInfo.value.split(",")[1] +
            //       "</i>"
            //     );
            //   }
            // },
            allowEditing: false
          },
          {
            caption: "Quantity",
            dataField: "quantity",
            dataType: "number",
            width: 125,
            alignment: "center",
            editorOptions: {
              showSpinButtons: true,
              min: 0
            }
          },
          {
            caption: "Part of pending order",
            alignment: "center",
            width: 200,
            calculateDisplayValue(e) {
              return e.inExistingOrder ? "Yes" : "";
            },
            allowEditing: false
          }
        ],
        editing: {
          // allowDeleting: true,
          allowUpdating: true,
          mode: "cell",
          useIcons: true
        }
      }
    };
  },
  beforeMount() {
    debugger;
    if (this.ord) {
      if (this.ord.id) {
        return this.$store
          .dispatch("orders/getOrder", this.ord.id)
          .then(rsp => {
            this.editOrder = rsp.status === "Started";

            var details = {
              site_id: rsp.site_id,
              order_items: rsp.order_items
            };

            return this.$store
              .dispatch("orders/itemDupCheck", details)
              .then(dupResp => {
                if (dupResp) {
                  this.selectedOrder = rsp;
                } else {
                }
              });
          });
      } else {
        this.editOrder = this.ord.status === "Started";
        this.selectedOrder = this.ord;
      }
      // this.selectedOrder = this.ord;
    }
    // return this.$store.dispatch("orders/getOrders").then(() => {
    //   return this.$store.dispatch("accounts/getAccounts");
    // });
  },
  mounted() {
    if (!this.ord) {
      this.onFilterSelect("open");
    }
  },
  computed: {
    orders() {
      if (!this.$store) {
        return [];
      }
      var store = this.$store.getters["orders/store"];

      return store;

      var orders = this.$store.getters["orders/orders"];
      return orders ? orders : [];
    },
    items() {
      return this.$store.getters["sysItems/items"]
        ? this.$store.getters["sysItems/items"]
        : [];
    },
    accounts() {
      var accts = this.$store.getters["accounts/accounts"];
      debugger;
      if (accts.length === 0) {
        this.$store.dispatch("accounts/getAccounts").then(() => {
          return this.$store.getters["accounts/accounts"];
        });
      } else {
        return accts;
      }
    },
    siteOptions() {
      if (!this.$store) {
        return [];
      }
      var accounts = this.$store.getters["accounts/accounts"];

      var options = [];

      var optBuilder = accts => {
        var opts = [
          {
            value: null,
            text: "-- Please select a site --",
            disabled: true
          }
        ];
        accts.forEach(a => {
          var o = {
            label: a.name,
            options: []
          };

          a.sites.forEach(s => {
            o.options.push({
              value: s.id,
              text: a.name + " / " + s.name
            });
            o.options.sort((ab, b) => {
              if (ab && b) {
                var x = ab.text.toLowerCase();
                var y = b.text.toLowerCase();
                if (x < y) {
                  return -1;
                }
                if (x > y) {
                  return 1;
                }
              }
              return 0;
            });
          });

          opts.push(o);
          opts.sort((ab, b) => {
            debugger;
            if (a && b && ab.label && b.label) {
              var x = ab.label.toLowerCase();
              var y = b.label.toLowerCase();
              if (x < y) {
                return -1;
              }
              if (x > y) {
                return 1;
              }
            }
            return 0;
          });
        });

        return opts;
      };

      if (accounts.length === 0) {
        return this.$store.dispatch("accounts/getAccounts").then(() => {
          debugger;
          return optBuilder(this.$store.getters["accounts/accounts"]);
        });
      } else {
        return optBuilder(accounts);
      }
    },
    options() {
      if (!this.$store) {
        return [];
      }
      var cats = this.$store.getters["sysItems/categories"];
      var items = this.$store.getters["sysItems/items"];
      var opts = [];

      if (cats.length === 0) {
        this.$store.dispatch("sysItems/getItems").then(() => {
          cats = this.$store.getters["sysItems/categories"];
          items = this.$store.getters["sysItems/items"];

          cats.forEach(c => {
            var o = {
              label: c.name,
              options: []
            };

            var fi = items.filter(i => i.item_category_id === c.id);

            fi.forEach(ix => o.options.push({ value: ix.id, text: ix.name }));

            opts.push(o);
          });

          return opts ? opts : [];
        });
      } else {
        cats.forEach(c => {
          var o = {
            label: c.name,
            options: []
          };

          var fi = items.filter(i => i.item_category_id === c.id);

          fi.forEach(ix => o.options.push({ value: ix.id, text: ix.name }));

          opts.push(o);
        });

        return opts ? opts : [];
      }
    },
    site() {
      // var site;

      if (this.selectedOrder) {
        return this.$store.dispatch(
          "accounts/siteSearch",
          this.selectedOrder.site_id
        );
      } else if (this.user.site_id && this.user.site_id > 0) {
        return this.$store.dispatch("accounts/siteSearch", this.user.site_id);
      }
    },
    wasModified: {
      get() {
        return this.$store.getters["accounts/isDirty"];
      },
      set(val) {
        return this.$store.dispatch("accounts/flagChanges", val);
      }
    },
    user() {
      return this.$store.getters["user/proFile"];
    },
    authType() {
      return this.$store.getters["user/authType"];
    },
    filters: {
      get() {
        return this.$store.getters["orders/filters"];
      },
      set(val) {
        debugger;
        this.$store.dispatch("orders/filters", val);
      }
    },
    dueDate: {
      get() {
        debugger;
        var dt = new Date(
          this.selectedOrder.due_by ? this.selectedOrder.due_by : new Date()
        );
        return dt;
      },
      set(val) {
        debugger;
        var dt = [
          val,
          this.selectedOrder.due_by
            .toLocaleString("en-us", { hour12: false })
            .split(",")[1]
        ];

        dt = new Date(dt);
        debugger;
        this.selectedOrder.due_by = dt;
      }
    },
    dueTime: {
      get() {
        debugger;
        var time = this.selectedOrder.due_by.toLocaleString("en-us", {
          hour12: false
        });

        return time ? time.split(",")[1] : null;
      },
      set(val) {
        debugger;
        if (val.length === 0) {
          return;
        }

        var dt = [
          this.selectedOrder.due_by.toLocaleString().split(",")[0],
          val
        ];

        this.selectedOrder.due_by = new Date(dt);
      }
    },
    nextStatus() {
      debugger;
      var rsl;
      var stat = this.selectedOrder ? this.selectedOrder.status : null;
      if (!stat) {
        return null;
      }
      switch (stat) {
        case "Started":
          rsl = this.statusButton["Placed"];
          break;
        case "Placed":
          return this.statusButton["Acknowledged"];
          break;
        case "Acknowledged":
          rsl = this.statusButton["Shipped"];
          break;
        case "Shipped":
          rsl = this.statusButton["Delivered"];
          break;
        case "Delivered":
          rsl = this.statusButton["Delivered"];
          break;
        default:
          rsl = this.statusButton["Placed"];
          break;
      }
      return rsl;
    }
  },
  methods: {
    onFilterSelect(e) {
      if (!this.$refs["gOrd"]) {
        return;
      }
      const dg = this.$refs["gOrd"].instance;

      dg.refresh();
    },
    onAddOrder() {
      debugger;
      var order = {
        site_id: this.user.site_id > 0 ? this.user.site_id : null,
        user_name: this.user.name,
        account_name: this.user.account ? this.user.account : "",
        site_name: this.user.site ? this.user.site : "",
        order_items: [],
        created_at: new Date(),
        rush: 0,
        due_by: this.getDueBy(),
        placed: "--",
        status: "Started",
        add_favorite: false,
        shipped_via: ""
      };

      const loadOrder = me => {
        var isPromise = me.site instanceof Promise;

        if (isPromise) {
          me.site.then(site => {
            if (site) {
              debugger;
              site.favorite_Items.forEach(f => {
                var itm = me.items.find(i => i.id === f.item_id);

                if (itm) {
                  order.order_items.push({
                    item_id: itm.id,
                    order_id: 0,
                    quantity: 0,
                    description: itm.name,
                    delete: false,
                    add_favorite: false,
                    inExistingOrder: false
                  });
                }
              });

              var details = {
                site_id: order.site_id,
                order_items: order.order_items
              };

              return this.$store
                .dispatch("orders/itemDupCheck", order)
                .then(dupResp => {
                  debugger;
                  if (dupResp) {
                    // order.order_items = details.order_items;
                    me.selectedOrder = order;
                    me.editOrder = true;
                    me.wasModified = true;
                  } else {
                    return;
                  }
                });
              // me.selectedOrder = order;
              // me.editOrder = true;
              // me.wasModified = true;
            } else {
              debugger;
              var details = {
                site_id: order.site_id,
                order_items: order.order_items
              };
              return this.$store
                .dispatch("orders/itemDupCheck", order)
                .then(dupResp => {
                  if (dupResp) {
                    // order.order_items = details.order_items;
                    me.selectedOrder = order;
                    me.editOrder = true;
                    me.wasModified = true;
                  } else {
                    return;
                  }
                });
              // me.selectedOrder = order;
              // me.editOrder = true;
              // me.wasModified = true;
            }
          });
        } else {
          me.selectedOrder = order;
          me.editOrder = true;
          me.wasModified = true;
        }
      };

      if ((!order.id || order.id === 0) && order.order_items.length === 0) {
        //Check if items available
        if (this.items.length > 0) {
          loadOrder(this);
        } else {
          this.$store.dispatch("sysItems/getItems").then(() => {
            loadOrder(this);
          });
        }
      }
    },
    onSubmit(e) {
      if (e.preventDefault) {
        e.preventDefault();
      }

      this.submitted = true;

      debugger;
      if (!this.$refs.f.checkValidity()) {
        return;
      }

      this.saving = true;
      //Don't allow submission if there isn't at least one item with a quantity grater than 0:
      var selectedItems = this.selectedOrder.order_items.filter(
        i => i.quantity > 0
      );
      var cmd = this.selectedOrder.id
        ? "orders/updateOrder"
        : "orders/addOrder";

      if (e.srcElement.id === "sub") {
        //Remove any items that are of zero quantity since this order is now being placed:
        this.selectedOrder.order_items.forEach(i => {
          if (i.quantity === 0) {
            i.delete = true;
          }
        });

        debugger;
        if (selectedItems.length === 0) {
          this.saving = false;
          notify(
            "Quantity must be greater than one in at least one item!",
            "error",
            4000
          );
          return false;
        }

        if (this.selectedOrder.status === "Started") {
          this.selectedOrder.status = "Placed";
        }
      }

      debugger;
      return this.$store.dispatch(cmd, this.selectedOrder).then(rsp => {
        if (rsp) {
          this.reset();
        } else {
          this.saving = false;
          return false;
        }
        return true;
      });
      // if (this.selectedOrder.id) {
      //   if (e.srcElement.id === "sub") {
      //     debugger;

      //     if (this.selectedOrder.status === "Started") {
      //       this.selectedOrder.status = "Placed";
      //     }
      //     prepSubmission();
      //   }
      // } else {
      //   if (e.srcElement.id === "sub") {
      //     prepSubmission();
      //   } else {
      //     this.selectedOrder.status =
      //       e.srcElement.id === "sav" ? "Started" : "Placed";
      //     prepSubmission();
      //   }
      //   // return this.$store
      //   //   .dispatch("orders/addOrder", this.selectedOrder)
      //   //   .then(() => this.reset());
      // }
    },
    onCancelClick() {
      debugger;
      if (this.wasModified) {
        var msg = this.selectedOrder.id
          ? "<p>You have made changes to this order, are you sure you want to cancel these changes?</p>"
          : "You are about to discard this new order. <br/> Do you wish to proceed?";

        var msgBox = confirm(msg, "Confirmation").then(rsp => {
          debugger;

          if (rsp) {
            return this.reset();
          } else {
            return;
          }
        });
      } else {
        this.reset();
      }
    },
    onCancelOrderClick(e) {
      var msg =
        "<p>You are about to cancel the order and this action cannot be undone. \n" +
        "Do you wish to proceed?</p>";

      var msgBox = confirm(msg, "Confirmation").then((rsp, me = this) => {
        debugger;

        if (rsp) {
          me.$store
            .dispatch("orders/deleteOrder", me.selectedOrder.id)
            .then(() => {
              return me.reset();
            });
        } else {
          return;
        }
      });
    },
    onAddItem() {
      if (!this.selectedItem) {
        return;
      }

      var test = this.selectedOrder.order_items.find(
        i => i.item_id === this.selectedItem
      );

      if (test) {
        notify(
          "Item is already included on the list. \n" +
            "To change the quanitty, simply click on the quantity cell and change it.",
          "error",
          4000
        );
        return;
      }

      debugger;

      var itm = this.items.find(i => i.id === this.selectedItem);

      var item = this.selectedOrder.order_items.push({
        order_id: this.selectedOrder.id,
        item_id: this.selectedItem,
        description: itm ? itm.name : "",
        add_favorite: this.addToFavorite,
        quantity: 1
      });

      const dupCheck = (me, order) => {
        //Does Item exist in other order?
        var details = {
          site_id: order.site_id,
          order_items: order.order_items
        };
        debugger;
        return this.$store
          .dispatch("orders/itemDupCheck", order)
          .then(dupResp => {
            debugger;
            if (dupResp) {
              debugger;
              // order.order_items = details.order_items;
              me.selectedOrder.order_items = order.order_items;
              me.editOrder = true;
              me.wasModified = true;
              me.$refs.grdItems.instance.refresh();
            } else {
              return;
            }
          });
      };

      dupCheck(this, this.selectedOrder).then(() => {
        debugger;
        this.addToFavorite = false;
        this.selectedItem = null;
      });
    },
    onselectionchange(e) {
      //load items:
      if (e.data.id) {
        return this.$store.dispatch("orders/getOrder", e.data.id).then(rsp => {
          this.editOrder = rsp.status === "Started";

          var details = {
            site_id: rsp.site_id,
            order_items: rsp.order_items
          };
          debugger;
          return this.$store
            .dispatch("orders/itemDupCheck", details)
            .then(dupResp => {
              if (dupResp) {
                this.selectedOrder = rsp;
              } else {
              }
            });
        });
      } else {
        this.editOrder = e.data.status === "Started";
        this.selectedOrder = e.data;
      }

      // if (!this.selectedOrder) {
      //   return;
      // }

      // var site = this.$store.getters["accounts/siteSearch"](
      //   this.selectedOrder.site_id
      // );
      // debugger;
    },
    onRowUpdated(e) {
      this.wasModified = true;
    },
    onRemovingItem(e) {
      // If item is not yet in database we can simply delete the item.
      if (!e.data.id) {
        return;
      }
      debugger;
      e.data.delete = true;
      this.wasModified = true;

      e.cancel = true;

      var rowIndex = e.component.getRowIndexByKey(e.key);

      var $commandEditCell = e.component.getCellElement(
        rowIndex,
        "command:edit"
      );

      $commandEditCell.hidden = true;
      return;
    },
    onOrderUpdated() {
      var sites = this.$store.getters["accounts/allSites"];
      var site = sites.find(s => s.id === this.selectedOrder.site_id);
      var account = this.accounts.find(a => a.id === site.account_id);

      const dupCheck = (me, order) => {
        //Does Item exist in other order?
        debugger;
        var details = {
          site_id: order.site_id,
          order_items: order.order_items
        };
        debugger;
        return this.$store
          .dispatch("orders/itemDupCheck", order)
          .then(dupResp => {
            debugger;
            if (dupResp) {
              debugger;
              // order.order_items = details.order_items;
              me.selectedOrder.order_items = order.order_items;
              me.editOrder = true;
              me.wasModified = true;
              me.$refs.grdItems.instance.refresh();
              return;
            } else {
              return;
            }
          });
      };

      const loadFavorites = (site, me = null) => {
        site.favorite_Items.forEach(f => {
          debugger;
          var itm = order.order_items.find(i => i.id === f.item_id);

          if (!itm) {
            order.order_items.push({
              item_id: f.item_id,
              order_id: 0,
              quantity: 0,
              description: f.name,
              delete: false,
              add_favorite: false
            });
          }
        });

        debugger;
        if (!me) {
          console.error("No value passed for me");
          return;
        }
        dupCheck(me, order);
      };

      var order = this.selectedOrder;

      if (!order.order_id || order.order_id === 0) {
        debugger;

        order.order_items = [];

        var isPromise = this.site instanceof Promise;

        if (isPromise) {
          var me = this;
          this.site.then(site => {
            debugger;
            loadFavorites(site, me);
          });
        } else {
          loadFavorites(this.site);

          // this.site.favorite_Items.forEach(f => {
          //   var itm = this.order_items.find(i => i.id === f.item_id);

          //   if (itm) {
          //     order.order_items.push({
          //       item_id: itm.id,
          //       order_id: 0,
          //       quanitty: 0,
          //       description: itm.name,
          //       delete: false,
          //       add_favorite: false
          //     });
          //   }
          // });
        }

        // return dupCheck(this, order);
      }

      if (account) {
        this.selectedOrder.account_name = account.name;
        this.selectedOrder.site_name = site.name;
      } else {
        this.selectedOrder.account_name = "--";
        this.selectedOrder.site_name = "--";
      }
    },
    getSite(siteId) {
      if (!this.selectedOrder) {
        return {};
      }
      return this.$store.getters["accounts/site"];
    },
    toDate(dt) {
      return dt ? new Date(dt) : null;
    },
    toDateString(dt) {
      var date = dt ? new Date(dt) : null;

      return date ? date.toLocaleString() : "";
    },
    toTimeString(dt) {
      var date = dt ? new Date(dt) : null;

      return date ? date.toLocaleTimeString() : "";
    },
    onEditClick() {
      this.$store.dispatch("sysItems/getItems").then(() => {
        this.editOrder = !this.editOrder;
      });
      // this.$refs.oi.$_instance.repaint();
    },
    getDueBy() {
      //LinkDsg's default is 2 days from the order date and time is set to 5 PM.
      var today = new Date();
      var date =
        today
          .toJSON()
          .split("T")[0]
          .trim() + "T17:00:00";

      // date.setDate(date.getDate() + 4);

      // date.setHours(17);
      // date.setMinutes(0);
      // date.setSeconds(0);

      // return date;
      return date;
    },
    reset() {
      debugger;
      this.editOrder = false;
      this.wasModified = false;
      this.selectedOrder = null;
      this.addToFavorite = false;
      this.saving = false;
      this.submitted = false;
      window.location = "#/admin";
    },
    onStatusChange(e) {
      debugger;
      //**Need a dialog to confirm action**
      var msg = "<p>Are you sure you wish to change the order status?</p>";
      var id = e.id;
      var ord = this.selectedOrder;
      var getStat = this.getStatus;

      var msgBox = confirm(msg, "Confirmation").then(rsp => {
        debugger;

        if (rsp) {
          var curStat = ord.status;
          ord.status = getStat(id).text;
          //Submit order changes:
          //to avoid duplicating the submit function just for this,
          //we will create an object with only the properties
          //being used in that function
          var e = {
            srcElement: { id: "sub" }
          };

          debugger;
          if (!this.onSubmit(e)) {
            this.selectedOrder.status = curStat;
            return;
          }
        } else {
          return;
        }
      });
    },
    setNextStatus(e) {
      debugger;
      var rsl;
      switch (e) {
        case "Started":
          rsl = this.son["Placed"];
          break;
        case "sta":
          rsl = this.son["Placed"];
          break;
        case "Placed":
          rsl = this.statusButton["Acknowledged"];
          break;
        case "pla":
          rsl = this.statusButton["Acknowledged"];
          break;
        case "Acknowledged" || "ack":
          rsl = this.statusButton["Shipped"];
          break;
        case "ack":
          rsl = this.statusButton["Shipped"];
          break;
        case "Shipped" || "shi":
          rsl = this.statusButton["Delivered"];
          break;
        case "shi":
          rsl = this.statusButton["Delivered"];
          break;
        case "Delivered" || "del":
          rsl = this.statusButton["Delivered"];
          break;
        case "del":
          rsl = this.statusButton["Delivered"];
          break;
        default:
          rsl = this.statusButton["Placed"];
          break;
      }

      return rsl;
    },
    getStatus(e) {
      debugger;
      var rsl;
      switch (e) {
        case "Started":
          debugger;
          rsl = this.son["Started"];
          break;
        case "sta":
          debugger;
          rsl = this.son["Started"];
          break;
        case "Placed":
          rsl = this.statusButton["Placed"];
          break;
        case "pla":
          rsl = this.statusButton["Placed"];
          break;
        case "Acknowledged":
          rsl = this.statusButton["Acknowledged"];
          break;
        case "ack":
          rsl = this.statusButton["Acknowledged"];
          break;
        case "Shipped":
          rsl = this.statusButton["Shipped"];
          break;
        case "shi":
          rsl = this.statusButton["Shipped"];
          break;
        case "Delivered":
          rsl = this.statusButton["Delivered"];
          break;
        case "del":
          rsl = this.statusButton["Delivered"];
          break;
      }

      return rsl;
    },
    dateUpdated(e) {
      debugger;
      var raw =
        e.value instanceof Date
          ? e.value.toLocaleString("en-US", { hour12: false }).split(",")
          : e.value.split("T");

      var time = raw[1].split(":");

      var h = parseInt(time[0]),
        m = parseInt(time[1]),
        s = parseInt(time[2]);

      if (h >= 17 && (m >= 0 || s >= 0)) {
        time[0] = "17";
        time[1] = "00";
        time[2] = "00";
      }

      var newDate = raw[0] + "T" + time.join(":");

      this.selectedOrder.due_by = newDate;
    },
    onDateHover(e) {
      debugger;
      if (!e.component._isHidden) {
        e.component.open();
      } else {
        e.component.close();
      }
    },
    byteConvert(e) {
      this.selectedOrder.rush = e ? 1 : 0;
    },
    setTimeConstriant(type = "m") {
      switch (type) {
        case "m": //min
          var rsp = new Date();
          return rsp;
        case "x":
          var curDate = new Date(this.selectedOrder.due_by);

          var year = curDate.getFullYear() + 1,
            month = curDate.getMonth(),
            day = curDate.getDate() + 1;

          debugger;

          var rsp = new Date(year, month, day, 17, 0, 0, 0);
          return rsp;
        default:
          return null;
      }
    }
  }
};
</script>

<style>
:root {
  --foot-display: inline-flexbox;
}
</style>

<style scoped>
.order-header {
  font-style: italic;
  color: #224f6e;
}
.subtitle {
  font-style: italic;
  font-weight: 500;
  margin-left: auto;
  color: #3274a1;
}
.bg_shade {
  background: #013354 !important;
  position: relative;
  left: 0;
  top: 0;
  border-radius: 5px;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  z-index: 1;
}
.order-delayed {
  font-weight: bolder;
  font-style: italic;
  color: red;
}
.order-delivered {
  color: green;
  font-style: italic;
  font-weight: bold;
}
.order-content {
  color: #ffffff !important;
  z-index: 3;
}
/* .card .card-body {
  min-height: 300px;
} */
select {
  color: #013354 !important;
  font-weight: bold;
  z-index: 2;
}
.dx-box {
  color: #000000 !important;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/orders.vue